import createCache, { type EmotionCache } from "@emotion/cache";

const createEmotionCache = () => {
  // Type casting required only during the emotion TypeScript migration
  return createCache({ key: "remix-css" }) as EmotionCache;
};

export { createEmotionCache };
